module.exports = __webpack_public_path__ + "media/images/desktop/arrow-left-22fe173a0754d5340287e72d60a12e6c.svg";